export const POSITIVE_COLOR = "shadesOfDark.dark";
export const NEGATIVE_COLOR = "primaryColors.collabDefault.dark";
export const BALANCE_POSITIVE_COLOR = "success.light";
export const BALANCE_NEGATIVE_COLOR = "error.light";
